import { ArrowBackIos } from "@material-ui/icons";
import { Close } from "@material-ui/icons";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { buildRouteWithParams } from "../../helpers/build-route-with-params";
import { cancelPendingBookingRequest } from "../../requests/pending-booking.requests";
import { pendingBookingStore } from "../../stores/pending-booking.store";

interface IProps {
  route: string;
  cancelPB?: boolean;
  action: string;
  handleClick?: () => void;
}

const ActionButtonLoad = styled.a`
  min-width: 32px;
  height: 32px;
  background: ${(props) => props.theme.backgroundTransparentWhite};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${(props) => props.theme.textColorDarken};
  }
`;

const ActionButtonLink = styled(Link)`
  min-width: 32px;
  height: 32px;
  background: ${(props) => props.theme.backgroundTransparentWhite};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${(props) => props.theme.textColorDarken};
  }
`;

const Button = (props: IProps) => {
  const handleOnClick = () => {
    if (props.cancelPB) {
      pendingBookingStore.resetBookingState();
      cancelPendingBookingRequest();
    }
    if (props.handleClick) {
      props.handleClick();
    }
  };

  const handleContent = (action: string) => {
    switch (action) {
      case "back":
        return (
          <ActionButtonLink
            id={action}
            data-test="back-button"
            to={buildRouteWithParams(props.route)}
            onClick={handleOnClick}
          >
            <ArrowBackIos />
          </ActionButtonLink>
        );
      default:
        return (
          <ActionButtonLoad
            id={action}
            data-test="default-button"
            href={props.route}
            onClick={handleOnClick}
          >
            <Close />
          </ActionButtonLoad>
        );
    }
  };

  const content = handleContent(props.action);

  return <>{content}</>;
};
export const ActionButton = memo(Button);
